import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const SortIcon = ({
  width = "24",
  height = "24",
  style,
  onClick,
  rotate,
}: IconProps) => {
  return (
    <IconWrapper
      width={width}
      height={height}
      style={style}
      onClick={onClick}
      rotate={rotate}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill="#B3B3B3"
          d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h4q.425 0 .713.288T9 17t-.288.713T8 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h10q.425 0 .713.288T15 12t-.288.713T14 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z"
        ></path>
      </svg>
    </IconWrapper>
  );
};
